import ajaxRequest from './ajax'
import qs from "qs"


export const query_integrals = params => {
  return ajaxRequest.post("integral/query_integrals" , params);
}

export const get_integral_by_user = params => {
  return ajaxRequest.get("integral/get_integral_by_user");
}

export const add_integral = params => {
  return ajaxRequest.post("integral/add_integral" , params);
}
// 查询签到
export const get_user_is_checkin = params => {
  return ajaxRequest.get("integral/get_user_is_checkin");
}



// WEBPACK FOOTER //
// ./src/api/integrals.js